import { createFileRoute } from '@tanstack/react-router';
import { ManageToolsPage } from '@/pages/member-portal/tools/ManageToolsPage';

// Authoring list for member-portal tools (HQ admin).
function MemberPortalManageToolsRoute() {
	return <ManageToolsPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/manage/tools')({
	component: MemberPortalManageToolsRoute,
});
